const randomIndex = () => {
  let index = Math.floor(Math.random() * 100000);

  return index;
};

export default randomIndex;
